export default __webpack_public_path__ + "static/media/mobile_banner_mansoon.575a822c.jpg";